import React from 'react';
import { Card, Timeline } from 'antd';
import { ClockCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../Shared/GlobalContext/ThemeContext';
import { formatFullTime } from '../../../../utils/messageRenderUtils';

const MessageStatusTimeline = ({ status, sentAt }) => {
    const { t } = useTranslation();
    const { isDarkMode } = useTheme();

    if (!status) return null;

    const themeColors = {
        cardBackground: isDarkMode ? '#1f1f1f' : '#fff',
        timelineDot: isDarkMode ? '#fff' : undefined,
    };

    return (
        <Card title={t('status')} style={{ background: themeColors.cardBackground }}>
            <Timeline
                items={[
                    {
                        dot: <ClockCircleOutlined style={{ color: themeColors.timelineDot }} />,
                        children: `${t('sent_at')} ${formatFullTime(sentAt)}`
                    },
                    status.delivered && {
                        dot: <CheckCircleOutlined style={{ color: themeColors.timelineDot }} />,
                        children: `${t('delivered_at')} ${formatFullTime(status.delivered_at)}`
                    },
                    status.read && {
                        dot: <CheckCircleOutlined style={{ color: themeColors.timelineDot }} />,
                        children: `${t('read_at')} ${formatFullTime(status.read_at)}`
                    }
                ].filter(Boolean)}
            />
        </Card>
    );
};

export default MessageStatusTimeline;
